<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          class="mr-1"
          small
          color="primary"
          dark
          v-on="{ ...tooltip }"
          v-on:click="() => (dialog = !dialog)"
        >
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("referenceBooks.users.Config") }}</span>
    </v-tooltip>
    <DragForm v-model="dialog">
      <v-card class="pb-0 mb-0" width="1200" height="600">
        <v-card-title>
          <span class="headline"
            >{{ $t("referenceBooks.users.Config") }} "{{ user.name }}"</span
          >
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">{{
            $t("Close")
          }}</v-btn>
          <v-btn color="blue darken-1" text @click="save" :disabled="!valid">{{
            $t("Save")
          }}</v-btn>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="4">
                {{ $t("referenceBooks.users.UserName") }}:{{ user.name }}
              </v-col>
              <v-col cols="4">
                {{ $t("referenceBooks.users.BankName") }}:{{ user.bankName }}
              </v-col>
              <v-col cols="4" v-if="user.branchName">
                {{ $t("referenceBooks.users.BranchName") }}:{{
                  user.branchName
                }}
              </v-col>
            </v-row>

            <v-row class="pa-0 ma-0">
              <v-col cols="3" class="pa-0 ma-0">
                <v-navigation-drawer
                  permanent
                  width="100%"
                  class="pa-0 ma-0"
                  :value="true"
                >
                  <v-list class="pa-0 ma-0">
                    <v-list-item-group class="pa-0 ma-0">
                      <v-list-item v-for="(role, i) in selectedRoles" :key="i">
                        <v-list-item-content>
                          <v-list-item-title>{{
                            role.description
                          }}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn
                            small
                            color="primary"
                            dark
                            icon
                            @click="
                              selectedRoles = selectedRoles.filter(
                                (sr) => sr.roleId !== role.roleId
                              )
                            "
                          >
                            <v-icon color="black lighten-1">mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                  <template v-slot:prepend>
                    <v-row>
                      <v-col cols="7" class="ml-1">
                        <h2>
                          {{ $t("SelectedCount", [selectedRoles.length]) }}
                        </h2>
                      </v-col>
                      <v-col cols="4">
                        <div>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on: tooltip }">
                              <v-btn
                                color="primary"
                                small
                                v-on="{ ...tooltip }"
                                v-on:click="
                                  () =>
                                    (rolesSelectingDialog =
                                      !rolesSelectingDialog)
                                "
                              >
                                <v-icon> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            {{ $t("SelectRoles") }}
                          </v-tooltip>
                          <v-dialog v-model="rolesSelectingDialog" width="500">
                            <v-card width="500">
                              <v-card-title>{{
                                $t("SelectRoles")
                              }}</v-card-title>
                              <v-card-text>
                                <v-data-table
                                  :items="roles"
                                  :item-key="'roleId'"
                                  :headers="rolesHeaders"
                                  show-select
                                  v-model="selectedRolesCopy"
                                  disable-pagination
                                  disable-sort
                                  disable-filtering
                                  hide-default-footer
                                />
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer />
                                <v-btn
                                  @click="rolesSelectingDialog = false"
                                  dark
                                  color="primary"
                                  small
                                  >{{ $t("Close") }}
                                </v-btn>
                                <v-btn
                                  @click="onSaveSelectedRoles"
                                  dark
                                  color="primary"
                                  small
                                  >{{ $t("Save") }}
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                </v-navigation-drawer>
              </v-col>
              <v-col cols="6">
                <v-data-table
                  :headers="rightsHeaders"
                  :items="availableRights"
                  :loading="loading"
                  item-key="rightId"
                  v-model="selectedRight"
                  height="400"
                  show-select
                  disable-pagination
                  disable-sort
                  disable-filtering
                  hide-default-footer
                  single-select
                  fixed-header
                >
                  <template v-slot:item.rightId="{ item }">
                    {{ $t("rightsNames.rightName" + item.rightId) }}
                  </template>
                  <template v-slot:item.domainId="{ item }">
                    {{ $t("domainsNames.domainName" + item.domainId) }}
                  </template>
                  <template v-slot:item.banks="{ item }">
                    {{
                      item.banks && item.banks.length
                        ? item.banks[0].bankName
                        : ""
                    }}
                  </template>
                  <template v-slot:item.branches="{ item }">
                    {{
                      item.domainId !== 3
                        ? ""
                        : item.branches === null
                        ? 0
                        : item.branches.length
                    }}
                  </template>

                  <template v-slot:top>
                    <h2>{{ $t("referenceBooks.roles.Rights") }}</h2>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="3" v-if="branchesTableIsVisible">
                <v-data-table
                  :headers="branchesHeaders"
                  :items="availableBranches"
                  :loading="loading"
                  item-key="branchId"
                  v-model="selectedRight[0].branches"
                  height="400"
                  show-select
                  disable-pagination
                  disable-sort
                  disable-filtering
                  hide-default-footer
                  fixed-header
                >
                  <template v-slot:top>
                    <h2>{{ $t("Branches") }}</h2>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions> </v-card-actions>
      </v-card>
    </DragForm>
  </div>
</template>

<script>
import Vue from 'vue';
import { notifyError, notifySuccess } from '@/services/notifications';
import DragForm from '@/components/Forms/DragForm.vue';

export default {
  components: {
    DragForm,
  },
  name: 'ConfigUserRolesAndRightsDialogAnotherVersion',
  data() {
    return {
      selectedRolesCopy: this.selectedRoles || [],
      rolesSelectingDialog: false,
      outputArrayFormKey: 0,
      currentUser: {},
      userRightsEdited: [],
      banks: [],
      branches: [],

      dialog: false,

      roles: [],
      selectedRoles: [],
      availableRights: [],

      selectedRoleToAdd: null,
      showMenu: false,
      selectedRight: [],
      loading: false,
    };
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  watch: {
    availableBranches(val) {
      if (this.selectedRight[0]?.branches.length > 0 && val.length === 0) return;
    },
    rolesSelectingDialog(val) {
      this.selectedRolesCopy = val ? this.selectedRoles : [];
    },
    showMenu(val) {
      if (!val) {
        this.onAddSelectedRoles();
      }
    },

    selectedRoles(val) {
      const rolesId = val.map((r) => r.roleId);
      this.availableRights = [];
      this.selectedRight = [];
      this.$axios.rights
        .getRightsByRolesArrayWithUserId(this.userId, rolesId)
        .then((response) => response.data)
        .then((json) => {
          this.availableRights = json;
          this.availableRights = this.decorateRights(this.availableRights);
        })
        .catch((error) =>
          Vue.notify({
            group: 'foo',
            title: 'Important message',
            text: error,
          })
        );
    },
    dialog(val) {
      if (val) {
        this.loadData();
      } else {
        this.clearData();
        this.$emit('rerender');
      }
    },
  },
  computed: {
    rightsHeaders() {
      return [
        {
          text: this.$t('referenceBooks.roles.RightName'),
          value: 'rightId',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.roles.Domain'),
          value: 'domainId',
          sortable: false,
        },
        { text: this.$t('Banks'), value: 'banks', sortable: false },
        { text: this.$t('Branches'), value: 'branches', sortable: false },
      ];
    },
    banksHeaders() {
      return [
        {
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          sortable: false,
        },
      ];
    },
    branchesHeaders() {
      return [
        {
          text: this.$t('referenceBooks.branches.Name'),
          value: 'name',
          sortable: false,
        },
      ];
    },
    valid() {
      return this.availableRights.every((item) => {
        return item.domainId === 1
          ? true
          : item.domainId === 2
            ? item.banks && item.banks.length
            : item.domainId === 3
              ? item.branches && item.branches.length
              : false;
      });
    },
    rolesHeaders() {
      return [
        {
          text: this.$t('referenceBooks.roles.RoleName'),
          value: 'description',
        },
      ];
    },
    availableBranches() {
      if (!this.selectedRight[0]?.banks.length) return [];

      return this.branches.filter((br) =>
        this.selectedRight[0]?.banks.some((b) => b.bankId === br.bankId)
      );
    },
    userId() {
      return this.user.userId;
    },
    userBankId() {
      return this.user.bankId;
    },
    userBranchId() {
      return this.user.branchId;
    },
    notSelectedRoles() {
      return this.roles.filter(
        (r) => !this.selectedRoles.some((sr) => sr.roleId == r.roleId)
      );
    },
    // outputUserRightsArray() {
    //   return this.makeOutputUserRightsArray(this.availableRights);
    // },

    banksTableIsVisible() {
      return (
        !!this.selectedRight[0] &&
        (this.isBankDomain(this.selectedRight[0]) ||
          this.isBranchDomain(this.selectedRight[0]))
      );
    },
    branchesTableIsVisible() {
      return (
        !!this.selectedRight[0] && this.isBranchDomain(this.selectedRight[0])
      );
    },
  },

  methods: {
    outputUserRightsArray() {
      return this.makeOutputUserRightsArray(this.availableRights);
    },
    onSaveSelectedRoles() {
      this.selectedRoles = this.selectedRolesCopy;
      this.rolesSelectingDialog = false;
    },
    onAddSelectedRoles() {
      this.selectedRoles.push(...this.selectedRoleToAdd);
      this.selectedRoleToAdd = [];
    },
    onClose() {
      this.$emit('rerender');
    },
    decorateRights(rightsArray) {
      return rightsArray
        .map((right) => {
          if (!right.banks) right.banks = [];
          if (!right.branches) right.branches = [];

          return right;
        })
        .map((right) => {
          if (this.isBankDomain(right) || this.isBranchDomain(right))
            if (right.banks.length === 0 && this.userBankId !== 0) {
              right.banks = [
                this.banks.find((b) => b.bankId === this.userBankId),
              ];
            }
          if (this.isBranchDomain(right)) {
            if (right.branches.length === 0 && this.userBranchId !== 0) {
              right.branches = [
                this.branches.find((br) => br.branchId === this.userBranchId),
              ];
            }
          }

          return right;
        });
    },
    makeForAllDomain(right) {
      return [
        {
          rightId: right.rightId,
          domainId: right.domainId,
          bankId: 0,
          branchId: 0,
        },
      ];
    },
    makeForBankDomain(right) {
      return right.banks.length
        ? right.banks.map((bank) => {
          return {
            rightId: right.rightId,
            domainId: right.domainId,
            bankId: bank.bankId,
            branchId: 0,
          };
        })
        : [
          {
            rightId: right.rightId,
            domainId: right.domainId,
            bankId: 0,
            branchId: 0,
          },
        ];
    },
    makeForBranchDomain(right) {
      return right.branches.length
        ? right.branches.map((branch) => {
          return {
            rightId: right.rightId,
            domainId: right.domainId,
            bankId: 0,
            branchId: branch.branchId,
          };
        })
        : [
          {
            rightId: right.rightId,
            domainId: right.domainId,
            bankId: 0,
            branchId: 0,
          },
        ];
    },
    makeOutFromSingleRight(right) {
      if (this.isAllDomain(right)) {
        return this.makeForAllDomain(right);
      } else if (this.isBankDomain(right)) {
        return this.makeForBankDomain(right);
      } else if (this.isBranchDomain(right)) {
        return this.makeForBranchDomain(right);
      }
    },
    makeOutputUserRightsArray(rightsArray) {
      let result = [];
      rightsArray.forEach((right) => {
        result = [...result, ...this.makeOutFromSingleRight(right)];
      });

      return result;
    },
    isAllDomain(right) {
      return right.domainId === 1;
    },

    isBankDomain(right) {
      return right.domainId === 2;
    },
    isBranchDomain(right) {
      return right.domainId === 3;
    },
    onUpdate(items) {
      this.selectedRight = items;
    },
    save() {
      const rolesId = this.selectedRoles.map((r) => r.roleId);
      const outputArray = this.outputUserRightsArray();

      const data = {
        roles: rolesId,
        userRights: outputArray,
      };

      this.$axios.users
        .setRolesAndRights(this.userId, data)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.RightsWereAttachedToUser', [this.user.name])
          );
          this.$emit('changed', this.userId);
          this.dialog = false;
        })
        .catch((error) => {
          notifyError('', this.$t('Error'));
          console.error(error);
        });
    },
    close() {
      this.clearData();
      this.dialog = false;
    },
    async loadData() {
      await this.$axios.banks
        .get()
        .then((response) => response.data)
        .then((json) => (this.banks = json))
        .catch((error) =>
          Vue.notify({
            group: 'foo',
            title: 'Important message',
            text: error,
          })
        );

      await this.$axios.branches
        .getByBanksArrayForUsersPage(this.banks.map((b) => b.bankId))
        .then((response) => response.data)
        .then((json) => (this.branches = json))
        .catch((error) => {
          notifyError(this.$t('Error'), error.response.data);
          console.error(error);
        });

      await this.$axios.roles
        .get()
        .then((response) => response.data)
        .then((json) => (this.roles = json))
        .catch((error) =>
          Vue.notify({
            group: 'foo',
            title: 'Important message',
            text: error,
          })
        );

      this.selectedRoles = this.user.roles;
    },
    clearData() {
      this.banks = [];
      this.branches = [];
      this.outputUserRightsArray = [];
      this.roles = [];
      this.selectedRoles = [];
      this.availableRights = [];
    },
  },
};
</script>
